<template>
  <store-finder />
</template>

<script>
import StoreFinder from "@/components/SUPPORT/StoreFinder.vue";

// 매장찾기 화면 본체는 StoreFinder (상담 신청 화면의 매장 선택에서도 재사용)
export default {
  name: "StoreLocator",
  components: { StoreFinder },
};
</script>
